var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2513 10.4987C3.2513 9.0737 4.40964 7.91536 5.83464 7.91536H9.16797V6.33203H5.83464C3.53464 6.33203 1.66797 8.1987 1.66797 10.4987C1.66797 12.7987 3.53464 14.6654 5.83464 14.6654H9.16797V13.082H5.83464C4.40964 13.082 3.2513 11.9237 3.2513 10.4987ZM6.66797 11.332H13.3346V9.66536H6.66797V11.332ZM14.168 6.33203H10.8346V7.91536H14.168C15.593 7.91536 16.7513 9.0737 16.7513 10.4987C16.7513 11.9237 15.593 13.082 14.168 13.082H10.8346V14.6654H14.168C16.468 14.6654 18.3346 12.7987 18.3346 10.4987C18.3346 8.1987 16.468 6.33203 14.168 6.33203Z",
    fill: "#007086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5585c1c462476ca143fd963073527252.svg";
export { ForwardRef as ReactComponent };